import React, { forwardRef } from 'react';
import cn from '@/utils/cn';

interface CardBodyProps extends React.ComponentPropsWithoutRef<'div'> {
  children: React.ReactNode;
  className?: string;
}

const CardBody = forwardRef<HTMLDivElement, CardBodyProps>(({
  children,
  className = '',
  ...rest
}, ref) => <div ref={ref} className={cn('tw-p-3', className)} {...rest}>{children}</div>);

export default CardBody;
